import { Component, Input } from '@angular/core'

@Component({
  selector: 'jml-lib-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent {
  @Input() value: string = ''
}
